import { Box, Skeleton } from "@mui/material";
import type { FC } from "react";
import { RADIUS, SLATE } from "../utils/styleTokens";

const HiringPageSkeleton: FC = () => (
	<Box data-testid="hiring-page-skeleton">
		<Box sx={{ mb: 5, display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
			<Box>
				<Skeleton variant="text" width={220} height={36} />
				<Skeleton variant="text" width={300} height={20} sx={{ mt: 0.5 }} />
				<Skeleton variant="text" width={140} height={16} sx={{ mt: 1 }} />
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
				<Skeleton variant="rectangular" width={200} height={44} sx={{ borderRadius: RADIUS.xl }} />
				<Skeleton variant="rectangular" width={160} height={44} sx={{ borderRadius: RADIUS.xl }} />
			</Box>
		</Box>

		<Box
			sx={{
				bgcolor: "white",
				borderRadius: RADIUS["3xl"],
				border: `1px solid ${SLATE[200]}`,
				p: 4,
				mb: 4,
				display: "flex",
				flexDirection: { xs: "column", md: "row" },
				alignItems: { md: "center" },
				justifyContent: "space-between",
				gap: 3,
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
				<Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: RADIUS.md }} />
				<Box>
					<Skeleton variant="text" width={180} height={28} />
					<Skeleton variant="text" width={140} height={18} />
				</Box>
			</Box>
			<Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 4 }}>
				{[0, 1, 2, 3].map((i) => (
					<Box key={i}>
						<Skeleton variant="text" width={70} height={12} />
						<Skeleton variant="text" width={60} height={36} />
					</Box>
				))}
			</Box>
		</Box>

		<Box sx={{ mb: 4 }}>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
				<Skeleton variant="text" width={140} height={20} />
				<Skeleton variant="text" width={80} height={20} />
			</Box>
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
					gap: 1.5,
				}}
			>
				{[0, 1, 2, 3, 4, 5].map((i) => (
					<Skeleton key={i} variant="rounded" height={88} sx={{ borderRadius: RADIUS.lg }} />
				))}
			</Box>
		</Box>

		<Box
			sx={{
				borderRadius: RADIUS["2xl"],
				bgcolor: "white",
				border: `1px solid ${SLATE[200]}`,
				overflow: "hidden",
				mb: 4,
			}}
		>
			<Box sx={{ p: 2.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<Skeleton variant="text" width={160} height={22} />
				<Skeleton variant="circular" width={20} height={20} />
			</Box>
			<Skeleton variant="rectangular" height={48} sx={{ bgcolor: SLATE[200] }} />
			<Box sx={{ p: 2 }}>
				{[0, 1, 2].map((i) => (
					<Skeleton key={i} variant="rectangular" height={56} sx={{ mb: 1, borderRadius: RADIUS.md }} />
				))}
			</Box>
		</Box>
	</Box>
);

export default HiringPageSkeleton;
